class ShoppableGallery extends HTMLElement {
  connectedCallback() {
    this.modal = this.querySelector('.shop-gallery-modal');
    this.slides = Array.from(this.querySelectorAll('.shop-gallery-modal__slide'));
    this.index = 0;
    if (!this.modal || this.slides.length === 0) return;

    this.querySelectorAll('[data-sg-open]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open(parseInt(btn.dataset.sgOpen, 10) || 0);
      });
    });

    this.modal.querySelectorAll('[data-sg-close]').forEach((el) =>
      el.addEventListener('click', () => this.close())
    );
    this.modal.querySelector('[data-sg-prev]')?.addEventListener('click', () => this.go(-1));
    this.modal.querySelector('[data-sg-next]')?.addEventListener('click', () => this.go(1));

    // Click on the backdrop (the <dialog> element itself) closes.
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.close();
    });
    // Arrow keys navigate while open.
    this.modal.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.go(-1);
      else if (e.key === 'ArrowRight') this.go(1);
    });
    // Native close (Esc / .close()) — clean up the scroll lock.
    this.modal.addEventListener('close', () =>
      document.body.classList.remove('shop-gallery-modal-open')
    );
  }

  open(i) {
    this.index = i;
    this.render();
    if (typeof this.modal.showModal === 'function') {
      if (!this.modal.open) this.modal.showModal();
    } else {
      this.modal.setAttribute('open', '');
    }
    document.body.classList.add('shop-gallery-modal-open');
  }

  close() {
    if (typeof this.modal.close === 'function' && this.modal.open) {
      this.modal.close();
    } else {
      this.modal.removeAttribute('open');
    }
    document.body.classList.remove('shop-gallery-modal-open');
  }

  go(dir) {
    const n = this.slides.length;
    this.index = (this.index + dir + n) % n;
    this.render();
  }

  render() {
    this.slides.forEach((s, i) => s.toggleAttribute('hidden', i !== this.index));
    const single = this.slides.length < 2;
    this.modal.querySelector('[data-sg-prev]')?.toggleAttribute('hidden', single);
    this.modal.querySelector('[data-sg-next]')?.toggleAttribute('hidden', single);
  }
}

if (!customElements.get('shoppable-gallery')) {
  customElements.define('shoppable-gallery', ShoppableGallery);
}
